import s from './GuestCategory.module.scss';
import GuestCard from './GuestCard';
import { sortGuests } from '../../../../../store/features/festivalProGuests';

export default function GuestCategory({ category, heading, guests }) {
  const sortedGuests = sortGuests(
    guests.map((guest) => ({ ...guest, category })),
  );

  return (
    <div id={heading} className={s.wrapper}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <h2 className={s.heading}>{heading}</h2>
            <div className={s.body}>
              <div className="row">
                {sortedGuests.map((guest) => (
                  <div key={guest.id} className="col-xs-6 col-sm-3">
                    <GuestCard guest={guest} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
